import { Component } from '@angular/core'

@Component({
    selector: 'fbr-auth-app-shell',
    template: ' <router-outlet></router-outlet> '
})
export class AuthAppShellComponent {
    constructor() {}
}
